import { Box, Link } from '@mui/material';
import { Typography } from '@sm-dashboard/ui-components';
import React, { ReactNode } from 'react';

const AUTO_REFRESH_KEY = 'errorBoundaryAutoRefresh';
const AUTO_REFRESH_WINDOW_MS = 5000;

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  override render() {
    if (this.state.hasError) {
      const lastAutoRefreshAt = Number(sessionStorage.getItem(AUTO_REFRESH_KEY));
      const shouldAutoRefresh =
        Number.isNaN(lastAutoRefreshAt) || Date.now() - lastAutoRefreshAt > AUTO_REFRESH_WINDOW_MS;

      if (shouldAutoRefresh) {
        sessionStorage.setItem(AUTO_REFRESH_KEY, String(Date.now()));
        window.location.reload();
        return null;
      }

      return (
        <Box
          sx={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            px: 2
          }}
        >
          <Box sx={{ mb: '0.35em' }}>
            <Typography variant="h1" color="error.main">
              משהו השתבש בטעינת עמוד זה
            </Typography>
          </Box>
          <Box sx={{ mb: '0.35em' }}>
            <Typography variant="subtitle1" color="text.secondary">
              ניתן לנסות{' '}
              <Link
                component="button"
                variant="inherit"
                onClick={() => window.location.reload()}
                sx={{ fontWeight: 'bold', fontSize: 'inherit', verticalAlign: 'baseline' }}
              >
                לרענן את הדף
              </Link>{' '}
              או{' '}
              <Link
                component="button"
                variant="inherit"
                onClick={() => {
                  window.history.back();
                  setTimeout(() => {
                    window.location.reload();
                  }, 100);
                }}
                sx={{ fontWeight: 'bold', fontSize: 'inherit', verticalAlign: 'baseline' }}
              >
                לחזור לעמוד הקודם
              </Link>
            </Typography>
          </Box>
          <Box sx={{ mt: 4 }}>
            <Typography variant="body2" color="text.secondary">
              הערה: לעיתים תוסף התרגום האוטומטי של Google Translate גורם לבעיות במערכת.
              <br />
              מומלץ לכבות אותו במידת הצורך.
            </Typography>
          </Box>
          <Box sx={{ mt: 4 }}>
            <Typography variant="body2" color="text.secondary">
              במידה והבעיה נמשכת, ניתן לפנות לתמיכה: <b>051-5415770</b>
            </Typography>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}
